import Header from "../components/header";
import PageTitle from "../components/page-title";
import PageNavigator from "../components/page-navigator";
import FeedHolder from "../components/feed-holder";
import InputModule from "../components/input-module";
import Holder from "../components/holder";
import FreeTrialBanner from "../components/free-trial-banner";
import { useState,useEffect } from "react";
import { openSiteAdder } from "../functions/openInput";
import { openCustomPostModule } from "../functions/openCustomPostModule";
import CustomPostModule from "../components/custom-post-module";
import { fetchFeed } from "../functions/fetchFeed";

function FeedPage({serverStatus}){
    //SCHEMA FOR FEED ITEM = {date:'09 Jun 2024',tag:'New content',site:'matt-bristow.com',url:'https://www.matt-bristow.com/why-im-great',title:'Why I Am Perfect And All My Competitors Suck',excerpt:'Download this light, bulb, lamp, creative, idea icon. Available in PNG and SVG formats. No signup required.'},

    const [inputOpen,setInputOpen] = useState(false);
    const [feedItems,setFeedItems] = useState([]);
    const [fullyLoaded, changeFullyLoaded] = useState(false);
    const [inputLength,setInputLength] = useState(null);

    const handleClick = () => {
        openSiteAdder(setInputOpen,inputOpen);
    }
    const [customPostModuleOpen,setCustomPostModuleOpen] = useState(false);

    const handleClick2 = () =>{
        openCustomPostModule(setCustomPostModuleOpen,customPostModuleOpen)
    }

    useEffect(() => {
        const waitForData = async() => {
        await fetchFeed(setFeedItems,setInputLength);
        changeFullyLoaded(true);
        }
        waitForData();
      }, []);


    return <>
    {serverStatus === 206 && <FreeTrialBanner />}
    <Header CTA='Add site' functionForButton={handleClick} CTA2="Create post" functionForButton2={handleClick2}></Header>
    <Holder 
    left={<PageNavigator numberSelected={0}/>}
    right={<><PageTitle text='Peruse what your sites have been posting.' heading='Your feed'></PageTitle>
    <FeedHolder openSiteAdder={handleClick} inputLength={inputLength} feedItems={feedItems} context='feed' isLoaded={fullyLoaded} setFeedItems={setFeedItems}/></>}
    />
    <InputModule functionForButton={handleClick} display={inputOpen ? 'flex' : 'none'}/>
    <CustomPostModule display={customPostModuleOpen ? 'flex' : 'none'} functionForButton={handleClick2} />

    </>
}
    
export default FeedPage;